<template>
  <div class="plan-row-item-bottom">
    <div v-if="displayLimited" class="plan-row-item-bottom__limited">
      <span class="plan-row-item-bottom__limited-text">Limited Time Availability</span>
    </div>
    <div v-else class="plan-row-item-bottom__learn-more">
      <a target="_blank" :href="link" class="plan-row-item-bottom__learn-more-link">
        <ExternalLinkIcon class="plan-row-item-bottom__learn-more-icon" />
        <span>See What's Included</span>
      </a>
    </div>
  </div>
</template>

<script>
import ExternalLinkIcon from '@/assets/icons/external_link_icon.svg'

export default {
  name: 'PlanRowItemBottom',
  components: {
    ExternalLinkIcon,
  },
  props: {
    link: {
      type: String,
      required: false,
    },
    displayLimited: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-row-item-bottom {
  height: 47px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--font-regular);
  font-size: rem(16px);
  color: var(--light-blue-gray);
  padding: 12px 24px;
  &__learn-more {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    gap: 10px;
    &-link {
      color: var(--purple-pale);
      font-style: normal;
      font-weight: 450;
      line-height: rem(20px);
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &--justify-f-end {
      justify-content: flex-end;
    }
  }
}
</style>
